import { render, staticRenderFns } from "./step-registration.vue?vue&type=template&id=c5e8eaf4&"
import script from "./step-registration.vue?vue&type=script&lang=js&"
export * from "./step-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports